import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuctionTemplateDetailTab from './AuctionTemplateDetailTab';
import useDetailHandler from '../../hooks/useDetailHandler';
import {
    auctionTemplatePropertiesType,
    auctionTemplateType,
} from '../../types';
import './_styles_/AuctionTemplateRow.css';
import { onActionKey } from '../../utils';

AuctionTemplateRow.propTypes = {
    auctionTemplate: auctionTemplateType.isRequired,
    auctionTemplateProps: auctionTemplatePropertiesType.isRequired,
};

function AuctionTemplateRow(props) {
    const {
        auctionTemplate,
        auctionTemplateProps,
    } = props;
    const { isDetailVisible, toggleDetail, onDetailDelete } = useDetailHandler(auctionTemplate.id);
    return (
        <>
            <div className="rich-list-row auction-template-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="auction-template-header--values--name">{auctionTemplate.name}</div>
                <div className="auction-template-header--values--product">{auctionTemplate.product && auctionTemplate.product.productId}</div>
                <div className="auction-template-header--values--description">{auctionTemplate.description}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <AuctionTemplateDetailTab
                    auctionTemplate={auctionTemplate}
                    onDetailDelete={onDetailDelete}
                    auctionTemplateProps={auctionTemplateProps}
                />
            )}
        </>
    );
}

export default AuctionTemplateRow;
